import styles from '../HardwarePayment/HardwarePayment.scss';
import orderSummaryStyles from '../OrderSummary.scss';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCheckout } from 'src/components/Checkout/CheckoutProvider';
import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import infoIcon from 'src/images/icons/info.svg';
import { Installments } from '../types';

interface SubtotalTitleProps {
  isCheckout?: boolean;
}

export const SubtotalTitle: React.FC<SubtotalTitleProps> = ({ isCheckout }) => {
  const { t } = useTranslation();
  const { selectedPurchaseType } = useCheckout();
  const [isTotalTooltip, setTotalTooltip] = useState<boolean>(false);

  const getSelectedPlan = () => {
    if (selectedPurchaseType === Installments.IP3) {
      return t('order-summary.three-installment-payment');
    }
    return t('order-summary.one-installment-payment');
  };

  return (
    <div className={styles.containerHeading}>
      <TextV2
        tagName="h4"
        variant="eyebrow"
        className={orderSummaryStyles.heading}
        value={t('order-summary.subtotal')}
      />
      {isCheckout && (
        <ClickAwayListener onClickAway={() => setTotalTooltip(false)}>
          <Tooltip
            title={`${t('order-summary.you-have-chosen')} ${getSelectedPlan()}`}
            open={isTotalTooltip}
            placement="top"
            arrow
            classes={{ popper: styles.tooltip }}
            data-test="subtotal-tooltip"
          >
            <Image
              src={infoIcon}
              className={styles.containerIcon}
              onClick={() => setTotalTooltip(!isTotalTooltip)}
              alt={t('info')}
              data-test="subtotal-info-icon"
            />
          </Tooltip>
        </ClickAwayListener>
      )}
    </div>
  );
};

SubtotalTitle.displayName = 'SubtotalTitle';
